import { royaltiesAndOtherPropertyPages } from './royaltiesAndOtherPropertyPages';

export default {
  title: 'Royalties and other assets',
  pages: royaltiesAndOtherPropertyPages,
};
